export default __webpack_public_path__ + "static/media/ali-saqlain-karachi-apartments.b4a9fbdc.jpg";